import IconArrowDown from 'asset/icon/arrow_down.svg'
import IconPin from 'asset/icon/geo/pin_f.svg'
import LoadingSpinner from 'component/block/loading/spinner'
import { useIsMobile } from 'store/server-context/device'
import cn from 'util/cn'

interface IDropdownMenuTitle {
  menuTitle: string
  loading?: boolean
  showCard: boolean
  showArrowIcon: boolean
  theme?: 'light' | 'still'
}
const DropdownMenuTitle = ({
  showArrowIcon,
  showCard,
  menuTitle,
  loading,
  theme
}: IDropdownMenuTitle) => {
  const isMobile = useIsMobile()

  return (
    <div
      className={cn(
        'flex cursor-pointer items-center justify-between rounded-full bg-glass_special-tips px-[8px] py-[6px]',
        isMobile ? 'min-w-0 max-w-full' : 'min-w-[160px] max-w-[398px]',
        theme === 'light' ? 'text-label-l1' : 'text-label_still-l1'
      )}
    >
      <IconPin width={18} height={18} className='mr-[4px]' />
      <div className='mr-[4px] max-w-[calc(100%_-_36px)] flex-shrink text-ellipsis text-lg font-bold truncate'>
        {menuTitle}
      </div>

      <div
        className={cn(
          'flex transform transition-all duration-300',
          showArrowIcon ? 'w-[18px] opacity-100' : 'w-0 opacity-0',
          showCard && 'rotate-180'
        )}
      >
        {loading ? (
          <div className='relative h-[18px] w-[18px]'>
            <LoadingSpinner size='sm' />
          </div>
        ) : (
          <IconArrowDown className='sq-[18px]' />
        )}
      </div>
    </div>
  )
}

export default DropdownMenuTitle
